<div class="wrap">
    <div class="container">
        <app-header></app-header>
    </div>
    <div class="aviso-container flex flex-col space-y-10 pt-36">
        <div class="max-w-4xl mx-auto">
            <h1 class="text-xl font-bold text-customPurple-600 mb-1 text-center">
                Términos y Condiciones del Programa de Invitación – Teu
            </h1>

            <small class="text-customBlack-500" style="text-align: center;display: block;">Vigente a partir del 20 de Enero de 2025</small>
                <br /><br />

            <div class="space-y-6 text-customBlack-500">

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        1. ¿Qué es el programa de invitación de Teu?
                </h2>
                <p class="text-justify">
                    Es un programa donde puedes invitar a personas que conozcas y que tengan un negocio, para que también accedan a un crédito con Teu. Si la persona se registra con tu invitación y obtiene su crédito, tú recibes una recompensa económica de $150 MXN por cada referido válido.
                </p>

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        2. ¿Quiénes pueden participar?
                </h2>
                <ul class="text-justify">
                    <li>- Clientes activos de Teu con historial vigente y al corriente en sus pagos.</li>
                    <li>- Deben haber sido invitados por Teu para participar en el programa (previa notificación directa).</li>
                    <li>- Cada cliente puede invitar hasta 10 personas durante la vigencia del programa, salvo que se indique lo contrario.</li>
                </ul>

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        3. ¿Qué se considera un referido válido?
                </h2>
                <p class="text-justify">
                    Para que una invitación sea válida y genere recompensa:
                </p>
                <ul class="text-justify">
                    <li>- El invitado <b>debe registrarse usando el código o enlace de referido proporcionado.</b></li>
                    <li>- Debe <b>completar exitosamente su proceso de solicitud y obtener su primer crédito con Teu.</b></li>
                    <li>- Debe <b>mantenerse al corriente en sus pagos.</b></li>
                    <li>- El crédito <b>debe ser utilizado para fines de negocio.</b></li>
                </ul>

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        4. ¿Cómo se entrega la recompensa?
                </h2>
                <ul class="text-justify">
                    <li>- Por cada referido válido, se otorgará una recompensa de <b>$150 MXN</b> al cliente referidor.</li>
                    <li>- <b>El pago se realiza vía transferencia bancaria o aplicación del monto como saldo a favor en el crédito vigente, según indique Teu.</b></li>
                    <li>- Las recompensas serán procesadas y notificadas dentro de los <b>10 días hábiles siguientes</b> a la validación del referido.</li>
                </ul>

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        5. Restricciones y condiciones importantes
                </h2>

                <ul class="text-justify">
                    <li>- No se permiten invitaciones masivas, campañas pagadas, ni uso de datos sin consentimiento.</li>
                    <li>- No se pueden invitar personas que ya estén en proceso con Teu o hayan sido clientes anteriormente.</li>
                    <li>- El programa está sujeto a validación antifraude. Teu se reserva el derecho de anular recompensas en caso de detección de prácticas indebidas.</li>
                    <li>- Las invitaciones son personales e intransferibles.</li>
                </ul>

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        6. Vigencia del programa
                </h2>
                <p class="text-justify">
                    El programa estará vigente <b>hasta nuevo aviso</b> o hasta alcanzar el cupo de invitaciones por cliente. Teu podrá modificar o finalizar esta promoción en cualquier momento, informando previamente a sus participantes.
                </p>

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        7. Contacto y dudas
                </h2>
                <p class="text-justify">
                    Para cualquier aclaración o consulta sobre este programa, comunícate directamente por WhatsApp al número oficial de Teu o con tu PromoTeur asignado. No se resolverán casos por otros canales no oficiales.
                </p>

                <h2 class="text-lg font-bold text-customPurple-600 mb-2">
                        Recuerda: Teu nunca solicita pagos por adelantado ni depósitos a cuentas personales. 
                        <br>Tu seguridad es primero.
                </h2>

            </div>
        </div>
    </div>
    <app-footer [colorClass]="footerColorClass"></app-footer>
</div>
